import type { InputMaybe, LongStayParamsInput } from "@/lib/gql/__generated__/graphql";

import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

type Props = {
	longStayParams: ForAutoGenerator<
		| {
				minimumStayDates?: number | undefined;
		  }
		| null
		| undefined,
		""
	>;
	onSetViewModel: (
		values: {
			key: "longStayParams";
			value: ForAutoGenerator<InputMaybe<LongStayParamsInput> | undefined, "">;
		}[],
	) => void;
};

export const usePlanLongStayParams = ({ longStayParams, onSetViewModel }: Props) => {
	const onSetLongStayParams = (value: number | undefined) => {
		if (value === undefined) {
			onSetViewModel([
				{
					key: "longStayParams",
					value: undefined,
				},
			]);
		} else {
			onSetViewModel([
				{
					key: "longStayParams",
					value: {
						minimumStayDates: {
							isEdited: true,
							value: value,
						},
					},
				},
			]);
		}
	};

	return {
		longStayParams,
		onSetLongStayParams,
	};
};
